var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_912_24568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4872 3.51281C18.2219 1.24755 15.2077 0 12 0C8.79226 0 5.77811 1.24755 3.51281 3.51281C1.24751 5.77806 0 8.79221 0 12C0 15.2078 1.24755 18.2219 3.51281 20.4872C5.77806 22.7525 8.79226 24 12 24C15.2077 24 18.2219 22.7524 20.4872 20.4872C22.7525 18.2219 24 15.2078 24 12C24 8.79221 22.7524 5.77811 20.4872 3.51281ZM12 22.5155C6.20175 22.5155 1.48454 17.7983 1.48454 12C1.48454 6.20175 6.20175 1.48454 12 1.48454C17.7983 1.48454 22.5155 6.20175 22.5155 12C22.5155 17.7983 17.7983 22.5155 12 22.5155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8335 6.16728C16.2765 4.6104 14.205 3.75293 12.0004 3.75293C9.79578 3.75293 7.72421 4.61035 6.16728 6.16728C4.61035 7.72421 3.75293 9.79578 3.75293 12.0004C3.75293 14.205 4.61035 16.2765 6.16728 17.8335C7.72421 19.3903 9.79578 20.2478 12.0004 20.2478C14.205 20.2478 16.2765 19.3904 17.8335 17.8335C19.3904 16.2765 20.2478 14.205 20.2478 12.0004C20.2478 9.79578 19.3904 7.72421 17.8335 6.16728ZM12.0004 18.7633C8.27131 18.7633 5.23747 15.7294 5.23747 12.0004C5.23747 8.27131 8.27131 5.23747 12.0004 5.23747C15.7294 5.23747 18.7633 8.27131 18.7633 12.0004C18.7633 15.7294 15.7294 18.7633 12.0004 18.7633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 7.50488C9.52123 7.50488 7.50488 9.52128 7.50488 11.9997C7.50488 14.4781 9.52123 16.4945 11.9997 16.4945C14.4782 16.4945 16.4945 14.4781 16.4945 11.9997C16.4945 9.52128 14.4782 7.50488 11.9997 7.50488ZM11.9997 15.01C10.3399 15.01 8.98942 13.6596 8.98942 11.9997C8.98942 10.3399 10.3399 8.98942 11.9997 8.98942C13.6596 8.98942 15.01 10.3399 15.01 11.9997C15.01 13.6596 13.6596 15.01 11.9997 15.01Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_912_24568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesTarget);
export default __webpack_public_path__ + "static/media/sales-target.4d203a4663810e3cc88c213ff1c3def6.svg";
export { ForwardRef as ReactComponent };